import React from 'react';
import FaAILoadingIcon from '../FactureeComponents/FaAILoadingIcon';
import {Box, Divider, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import ShowCode from "../helpers/ShowCode.js";

const FaAILoadingIconExmpl = () => {
  
  const example1 = `<>
  <FaAILoadingIcon />
</>`;

  const example2 = `<>
  <FaAILoadingIcon size={50} />
</>`;

  const example3 = `<>
  <FaAILoadingIcon 
    size={70} 
    sx={{ margin: '2rem' }} 
  />
</>`;

  return (
    <Box sx={{padding: '8rem 8vw 2rem 8vw'}}>
      <Typography variant={"h3"} sx={{marginBottom: '2rem'}}>FaAILoadingIcon Component</Typography>

      <Typography>The FaAILoadingIcon displays an animated AI loading indicator with a star and blinking dots.</Typography>

      <Divider sx={{marginTop: '2rem', marginBottom: '2rem'}}/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Default Size (35px)</Typography>
      <FaAILoadingIcon />
      <ShowCode codeString={example1} scope={{ React, FaAILoadingIcon }} />
      <br/>
      <Divider sx={{marginTop: '2rem', marginBottom: '2rem'}}/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Medium Size (50px)</Typography>
      <FaAILoadingIcon size={50} />
      <ShowCode codeString={example2} scope={{ React, FaAILoadingIcon }} />
      <br/>
      <Divider sx={{marginTop: '2rem', marginBottom: '2rem'}}/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Large Size with Custom Styling (70px)</Typography>
      <FaAILoadingIcon 
        size={70} 
        sx={{ margin: '2rem' }} 
      />
      <ShowCode codeString={example3} scope={{ React, FaAILoadingIcon }} />

      <Typography variant={"h4"} sx={{marginBottom: '0.5rem', marginTop: '3rem'}}>API Reference</Typography>
      <Typography variant={"body2"} color="text.secondary" sx={{marginBottom: '2rem'}}>
        Complete list of all props supported by the FaAILoadingIcon component.
      </Typography>

      <TableContainer component={Paper} sx={{marginBottom: '2rem', '& code': {fontSize: '0.875rem'}}}>
        <Table>
          <TableHead>
            <TableRow sx={{backgroundColor: 'primary.main'}}>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '20%'}}>Prop</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '25%'}}>Type</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '15%'}}>Default</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '40%'}}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell><code>id</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Optional ID attribute for the component container.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>size</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>number</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>35</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Size of the loading icon in pixels; scales the entire animation proportionally.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>sx</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Material-UI sx prop for custom styling of the container.</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant={"body2"} color="text.secondary" sx={{fontStyle: 'italic'}}>
        * Required prop
      </Typography>
    </Box>
  );
};

export default FaAILoadingIconExmpl;
